import ImportantNotificationDialogActionTypes from '../actions/important-notification-dialog-action-types';

const initialState = {
  loading: false,
  notificationCancelToken: null,
  notification: null,
  visible: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ImportantNotificationDialogActionTypes.LOAD_IMPORTANT_NOTIFICATION_DIALOG_NOTIFICATION_START:
      return {
        ...state,
        loading: true
      };
    case ImportantNotificationDialogActionTypes.LOAD_IMPORTANT_NOTIFICATION_DIALOG_NOTIFICATION_END:
      return {
        ...state,
        loading: false,
        notification: action.payload ? action.payload.notification : null
      };
    case ImportantNotificationDialogActionTypes.OPEN_IMPORTANT_NOTIFICATION_DIALOG:
      return {
        ...state,
        visible: true
      };
    case ImportantNotificationDialogActionTypes.CLOSE_IMPORTANT_NOTIFICATION_DIALOG:
      return {
        ...state,
        visible: false
      };
    case ImportantNotificationDialogActionTypes.UPDATE_IMPORTANT_NOTIFICATION_DIALOG_NOTIFICATION_CONFIRM_START:
      return {
        ...state,
        loading: true
      };
    case ImportantNotificationDialogActionTypes.UPDATE_IMPORTANT_NOTIFICATION_DIALOG_NOTIFICATION_CONFIRM_END:
      return {
        ...state,
        loading: false,
        notification: null
      };
    case ImportantNotificationDialogActionTypes.UPDATE_IMPORTANT_NOTIFICATION_DIALOG_NOTIFICATION_READ_START:
      return {
        ...state,
        loading: true
      };
    case ImportantNotificationDialogActionTypes.UPDATE_IMPORTANT_NOTIFICATION_DIALOG_NOTIFICATION_READ_END:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
};
